export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
  // Now set up the states
  $stateProvider
    .state("loginModule", {
      parent: "top",
      abstract: true,
      views: {
        top: {
          template: "<ui-view/>"
        }
      },
      data: {
        anonymousAccess: true,
        showLoginClass: true
      }
    });
}];



// WEBPACK FOOTER //
// ./src/ui/modules/eaLoginMain/routes.js